import React from "react";
import { useDarkMode } from "src/context/DarkModeContext";
import ExplanationCard from "src/components/cards/ExplanationCard/ExplanationCard";
import ExampleCard from "src/components/cards/ExampleCard/ExampleCard";
import ConjugationTable from "src/components/tables/ConjugationTable";
import PageStructure from "src/components/wrappers/PageStructure";
import ExampleTitle from "src/components/ExampleTitle";

import {
    preteritoPerfectoExplanation,
    preteritoPerfectoRegular,
    preteritoPerfectoIrregular,
    preteritoPerfectoExamplesData
} from "src/data/individual-topics/PresentPrefect";

const PreteritoPerfectoContent: React.FC = () => {
    const { isDarkMode } = useDarkMode();

    return (
        <div className={`${isDarkMode ? "dark" : ""}`}>
           
            <div className="section">
                <ExplanationCard cardData={preteritoPerfectoExplanation} />
            </div>

            <ExampleTitle />
            <div className="section" style={{ display: "flex", flexDirection: "column", gap: "20px" }}>
                {preteritoPerfectoExamplesData.map((example, index) => (
                    <ExampleCard key={index} example={example} />
                ))}
            </div>

            <div className="section">
                <ConjugationTable
                    tableData={{
                        title: "Regular Verbs",
                        verbs: preteritoPerfectoRegular,
                    }}
                />
            </div>

            <div className="section">
                <ConjugationTable
                    tableData={{
                        title: "Irregular Verbs",
                        verbs: preteritoPerfectoIrregular,
                    }}
                />
            </div>
        </div>
    );
};

const PreteritoPerfectoScreen: React.FC = () => {
    return (
        <PageStructure
            TitleNode="Present Perfect"
            Page={<PreteritoPerfectoContent />}
        />
    );
};

export default PreteritoPerfectoScreen;
